import { $axios } from '../../plugins/axios'

const state = () => ({
    materials: []
});

const getters = {
    getMaterials(state) {
        return state.materials;
    }
};

const mutations = {
    setMaterials(state, materials) {
        state.materials = materials;
    }
}

const actions = {
    getMaterials(vuexContext) {
        return $axios.get('/materials')
            .then(res => {
                // const marketId = getMarketId();
                // const materials = Array.isArray(res.data) ? res.data : [];
                // const visibleMaterials = marketId
                //     ? materials.filter(
                //         (material) => Number(material.market_id) === Number(marketId)
                //     )
                //     : materials;
                // const sortedMaterials = visibleMaterials.sort((a, b) => {
                //     const nameA = (a.name || '').toString();
                //     const nameB = (b.name || '').toString();
                //     return nameA.localeCompare(nameB);
                // });
                vuexContext.commit('setMaterials', res.data);
                return res.data;
            });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
